import React, { Component } from 'react';
import classnames from 'classnames';
import { getLangDir, Version, SPOILER_TYPE, GlobalContext, AccessibilityListener } from 'wix-rich-content-common';
import { v as viewerStyles } from '../RicosNodesRenderer-ded93bb2.js';
import { r as rtlStyles } from '../rtl.rtlignore-14004c1d.js';
import ContentTraverser from './ContentTraverser.js';
import AddAnchors from './components/AddAnchors.js';
import './rericos/render.js';
import './rericos/renderers/plugins/nodeViewContainer.js';
import 'lodash';
import '../getClassNames-ac378b13.js';
import 'ricos-context';
import './rericos/renderers/plugins/consts.js';
import 'ricos-schema';
import './rericos/utils/Anchorable.js';
import './rericos/renderers/plugins/ContainerElement.js';
import './rericos/utils/paywallSeo.js';
import './components/ErrorBoundary.js';
import './components/Anchor.js';
import './rericos/renderers/index.js';
import './rericos/renderers/paragraph/paragraph.js';
import '../alignment.rtlignore-df562120.js';
import '../indentation-1235154f.js';
import './rericos/renderers/consts.js';
import './rericos/renderers/blockquote/blockquote.js';
import 'ricos-converters';
import './rericos/renderers/codeblock/codeblock.js';
import './rericos/renderers/heading/heading.js';
import './rericos/renderers/lists/bulletedList.js';
import '../lists-6070a635.js';
import './rericos/renderers/lists/orderedList.js';
import './rericos/renderers/lists/listItem.js';
import './rericos/renderers/text/text.js';
import './rericos/decorators/index.js';
import 'ricos-common-plugins/viewer';
import './rericos/decorators/nodeViewDecorators.js';
import './rericos/decorators/breakoutDecorator.js';
import './rericos/renderers/plugins/getPluginRenderers.js';
import './rericos/renderers/plugins/fromTypeMapper.js';
import 'ricos-content/libs/convertNodeDataToDraftNoInnerRCE';
import './rericos/renderers/plugins/fromExternalNode.js';
import 'ricos-content/libs/struct-converters';
import 'ricos-styles';
import './defaults.js';
import './rericos/utils/SpoilerManager.js';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
class ContentViewer extends Component {
  constructor(props) {
    super(props);
    this.getContextualData = ({
      t,
      theme,
      isMobile = false,
      anchorTarget,
      relValue,
      customAnchorScroll,
      config,
      locale,
      disabled,
      seoMode,
      iframeSandboxDomain,
      textAlignment,
      experiments,
      textDirection,
      direction,
      helpers
    }) => {
      var _a;
      return {
        t,
        theme: theme || {},
        isMobile,
        anchorTarget,
        relValue,
        customAnchorScroll,
        config,
        helpers: helpers || {},
        locale: locale || "en",
        disabled,
        seoMode,
        iframeSandboxDomain,
        disableRightClick: (_a = config == null ? void 0 : config.uiSettings) == null ? void 0 : _a.disableRightClick,
        textAlignment,
        experiments,
        textDirection,
        languageDir: direction || getLangDir(locale)
      };
    };
    const { experiments = {}, isMobile = false, t } = props;
    this.styles = __spreadValues(__spreadValues({}, viewerStyles), rtlStyles);
    this.state = {
      context: { experiments, isMobile, t }
    };
  }
  componentDidMount() {
    this.reportDebuggingInfo();
  }
  reportDebuggingInfo() {
    if (typeof window === "undefined") {
      return;
    }
    if (/ricos-debug/i.test(window.location.search) && !window.__RICOS_INFO__) {
      import(
        /* webpackChunkName: "debugging-info" */
        'wix-rich-content-common/libs/debugging-info'
      ).then(({ reportDebuggingInfo }) => {
        reportDebuggingInfo({
          version: Version.currentVersion,
          reporter: "Rich Content Viewer",
          plugins: Object.keys(this.props.typeMappers),
          getContent: () => this.props.content,
          getConfig: () => this.props.config
        });
      });
    }
  }
  render() {
    var _a;
    const {
      config = {},
      onHover,
      isMobile,
      addAnchors,
      onMouseOver = () => {
      },
      content,
      setRef,
      typeMappers,
      nodeViewRenderers,
      nodeViewDecorators
    } = this.props;
    const { styles } = this;
    const SpoilerViewerWrapper = (_a = config[SPOILER_TYPE]) == null ? void 0 : _a.SpoilerViewerWrapper;
    const contextualData = this.getContextualData(this.props);
    const viewerClassName = classnames(styles.viewer, {
      [rtlStyles.rtl]: contextualData.textDirection === "rtl"
    });
    const dataId = { "data-id": "content-viewer" };
    return /* @__PURE__ */ React.createElement(GlobalContext.Provider, { key: "RicosViewer", value: this.state.context }, /* @__PURE__ */ React.createElement(
      "div",
      __spreadValues({
        className: styles.wrapper,
        dir: contextualData.languageDir,
        onMouseEnter: (e) => onHover && onHover(e),
        onMouseOver
      }, dataId),
      /* @__PURE__ */ React.createElement("div", { className: viewerClassName, ref: setRef }, /* @__PURE__ */ React.createElement(AddAnchors, { addAnchors }, /* @__PURE__ */ React.createElement(
        ContentTraverser,
        {
          content,
          typeMappers,
          context: contextualData,
          nodeViewRenderers,
          nodeViewDecorators,
          SpoilerViewerWrapper
        }
      ))),
      /* @__PURE__ */ React.createElement(AccessibilityListener, { isMobile })
    ));
  }
}
ContentViewer.defaultProps = {
  theme: {},
  locale: "en",
  config: {}
};

export { ContentViewer as default };
//# sourceMappingURL=ContentViewer.js.map
